import axios, { AxiosResponse } from 'axios' 
import { IBranchModel } from './BranchModel'
import { ApiResponse, PageResponse } from '../../../../shared/models/ApiModels'


const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

export const BRANCH_CREATE_URL = `${API_URL}api/v1/definition/branch/create`
export const BRANCH_GET_ALL_URL = `${API_URL}api/v1/definition/branch/all`
export const BRANCH_DELETE_URL = `${API_URL}api/v1/definition/branch/delete/`
export const BRANCH_UPDATE_URL = `${API_URL}api/v1/definition/branch/update/`

export function createBranch(branch: IBranchModel) {
  return axios.post(BRANCH_CREATE_URL, branch)
}

export async function loadBranches(
  page = 0, 
  size = 5, 
  sort: string = 'createdDate', 
  order: string = 'desc'
): Promise<AxiosResponse<ApiResponse<PageResponse<IBranchModel>>>> {
  return axios.get(BRANCH_GET_ALL_URL, {
    params: { page, size, sort, order }
  });
}

export function deleteBranch(branchId: String) {
  return axios.post(BRANCH_DELETE_URL + branchId)
}

export function updateBranch(branch: IBranchModel) {
  return axios.patch(BRANCH_UPDATE_URL + branch.id, branch)
}

 

